import { useState } from "react"
import type { GitlabIdentity } from "@/types"

// Like GitLab's identicons: a letter on a background picked from the user id, so it matches what teammates see.
const IDENTICON_COLORS = [
  "bg-red-100 text-red-800",
  "bg-purple-100 text-purple-800",
  "bg-blue-50 text-blue-800",
  "bg-blue-100 text-blue-900",
  "bg-green-100 text-green-800",
  "bg-orange-100 text-orange-900",
  "bg-gray-100 text-gray-800",
]

const SIZES = { sm: "size-7 text-xs", md: "size-9 text-sm", lg: "size-12 text-lg" }

type AvatarProps = {
  identity: Pick<GitlabIdentity, "id" | "name" | "avatar_url"> | null
  fallback?: string
  size?: keyof typeof SIZES
}

export default function Avatar({ identity, fallback = "", size = "md" }: AvatarProps) {
  const [failed, setFailed] = useState(false)
  const base = `${SIZES[size]} shrink-0 rounded-full`

  if (identity?.avatar_url && !failed) {
    return <img src={identity.avatar_url} alt="" className={`${base} object-cover`} onError={() => setFailed(true)} />
  }

  const letter = (identity?.name || fallback).trim().charAt(0).toUpperCase()
  const color = IDENTICON_COLORS[(identity?.id ?? 0) % IDENTICON_COLORS.length]
  return (
    <span aria-hidden="true" className={`${base} ${color} flex items-center justify-center font-semibold`}>
      {letter}
    </span>
  )
}
